import { useCallback } from 'react';

import { logger } from '@/utils/logging';

import { useTermsAndConditionsModal } from '../components/TermsAndConditionModalProvider';
import { LOG_TAG, type ShowTncSheet } from '../utils/terms-and-conditions-utils';
import { useHasUserAcceptedProductTerms } from './use-has-user-accepted-product-terms';

/**
 * Returns a callback that runs `onAccepted` immediately when the user has already
 * accepted the active product's terms, otherwise opens the T&C modal and runs
 * `onAccepted` after acceptance.
 */
export const useShowTncSheet = (): ShowTncSheet => {
    const { showTermsAndConditionsModal } = useTermsAndConditionsModal();
    const { isAccepted: hasAcceptedProductTerms } = useHasUserAcceptedProductTerms();

    return useCallback(
        onAccepted => {
            if (hasAcceptedProductTerms) {
                onAccepted();
                return;
            }
            showTermsAndConditionsModal({
                onSuccess: () => {
                    try {
                        onAccepted();
                    } catch (error) {
                        logger.error(LOG_TAG, 'Error accepting user terms and conditions', error);
                    }
                },
            });
        },
        [hasAcceptedProductTerms, showTermsAndConditionsModal]
    );
};
